import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 20000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('aqc_admin_token');
  if (token && config.url?.startsWith('/admin')) {
    config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` };
  }
  return config;
});

export const uploadUrl = (path) => (path?.startsWith('http') ? path : `${BASE}${path}`);

// Public
export const getSettings = () => api.get('/settings').then((r) => r.data);
export const getResources = () => api.get('/resources').then((r) => r.data);
export const submitContact = (payload) => api.post('/contact', payload).then((r) => r.data);
export const getSEO = (path) => api.get('/seo', { params: { path } }).then((r) => r.data);

// Admin
export const adminLogin = (email, password) =>
  api.post('/admin/login', { email, password }).then((r) => r.data);
export const adminMe = () => api.get('/admin/me').then((r) => r.data);
export const listSubmissions = (params = {}) =>
  api.get('/admin/submissions', { params }).then((r) => r.data);
export const patchSubmission = (id, payload) =>
  api.patch(`/admin/submissions/${id}`, payload).then((r) => r.data);
export const deleteSubmission = (id) =>
  api.delete(`/admin/submissions/${id}`).then((r) => r.data);
export const updateSettings = (payload) =>
  api.put('/admin/settings', payload).then((r) => r.data);
export const upsertSEO = (payload) => api.put('/admin/seo', payload).then((r) => r.data);
export const listSEO = () => api.get('/admin/seo').then((r) => r.data);
export const createResource = (formData) =>
  api
    .post('/admin/resources', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((r) => r.data);
export const deleteResource = (id) => api.delete(`/admin/resources/${id}`).then((r) => r.data);
export const changePassword = (old_password, new_password) =>
  api.post('/admin/change-password', { old_password, new_password }).then((r) => r.data);

// CMS: Pages / Services / Industries
export const getPage = (slug) => api.get(`/pages/${slug}`).then((r) => r.data);
export const listPages = () => api.get('/pages').then((r) => r.data);
export const updatePage = (slug, content) =>
  api.put(`/admin/pages/${slug}`, { content }).then((r) => r.data);

export const listServicesApi = () => api.get('/services').then((r) => r.data);
export const getServiceApi = (slug) => api.get(`/services/${slug}`).then((r) => r.data);
export const updateService = (slug, payload) =>
  api.put(`/admin/services/${slug}`, payload).then((r) => r.data);

export const listIndustriesApi = () => api.get('/industries').then((r) => r.data);
export const updateIndustry = (id, payload) =>
  api.put(`/admin/industries/${id}`, payload).then((r) => r.data);

// Media library
export const listMedia = () => api.get('/media').then((r) => r.data);
export const uploadMedia = (file, alt = '') => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('alt', alt);
  return api
    .post('/admin/media', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((r) => r.data);
};
export const deleteMedia = (id) => api.delete(`/admin/media/${id}`).then((r) => r.data);
